import { Api } from '@axiom/ui';
import type { ClientRequest, Event } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';
import type { ClientPassOnCandidate } from '../schema/client-pass-on-candidate';
import type { EngagementRequest } from '../schema/engagement-request';
import type { ClientTogglePinStatus } from '../schema/client-toggle-pin-status';

class ClientRequestApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  async createEngagementRequest(body: EngagementRequest) {
    return super.write<{
      data: { id: ClientRequest['id']; eventId: Event['id'] };
    }>({
      endpoint: `/clientRequest/requestEngagement`,
      method: 'PUT',
      body,
    });
  }

  async createPassOnCandidateRequest(body: ClientPassOnCandidate) {
    return super.write<{
      data: { id: ClientRequest['id']; eventId: Event['id'] };
    }>({
      endpoint: `/clientRequest/passOnCandidate`,
      method: 'PUT',
      body,
    });
  }

  async updatePinnedStatus(body: ClientTogglePinStatus) {
    return super.write<{ data: null }>({
      endpoint: `/clientRequest/pin`,
      method: 'PUT',
      body,
    });
  }
}

export const ClientRequestApi = new ClientRequestApiClass();
